<div class="info-body">
    <div class="info-header">
        <h2 class="info-title mb-0" mat-dialog-title>Create internal subscription</h2>
        <button type="button" class="close" (click)="closeDialog()" [disabled]="isSpinner">
            <img src="assets/Channels/cover_image/close.svg" alt="" class="close-icon">
        </button>
    </div>
    <div class="mat-content">
        <ng-container *ngIf="isLoading">
                <ngx-skeleton-loader 
                    *ngFor="let config of skeletonConfigs; let i = index"
                    [theme]="config">
                </ngx-skeleton-loader>
        </ng-container>
        <ng-container *ngIf="!isLoading">
            <div class="info-content mob-order-3">
                <div class="info-content-header">
                    <label for="" class="logo-label">Email<span class="req">*</span></label>
                    <span *ngIf="isInvalidEmail" class="err-msg">
                        <img src="assets/Channels/details_error.svg" alt="" width="13" height="14"> Enter correct email address. Ex: test@test.com
                    </span>
                </div>
                <input type="email" class="form-control" style="width: 401px; border: 1px solid #a5b6d7;" id="exampleFormControlInput1" placeholder="Enter Email ID"
                    [(ngModel)]="email" autocomplete="off" (keyup)="validateEmailFormat()" #emailInput >

                <div class="info-content-header" style="margin-top: 20px;">
                    <label for="" class="logo-label">Coupon<span class="req">*</span></label>
                </div>
                <input
                    type="text"
                    class="form-control"
                    style="width: 401px; border: 1px solid #a5b6d7"
                    id="couponInput"
                    placeholder="Enter Coupon Code"
                    [(ngModel)]="coupon"
                    autocomplete="off"
                    (input)="convertCouponToUpperCase()">

                <div class="info-content-header" style="margin-top: 20px;">
                    <label for="" class="logo-label">Plan<span class="req">*</span></label>
                </div>
                <app-single-select
                    [heading]="'Select Plan'"
                    [list]="planDocs"
                    [selectedEvent]="selectedPlan.key"
                    [dropDownName]="'planSelect'"
                    [width]="'401px'"
                    [index]="0"
                    (valueChanged)="onPlanSelected($event)"
                    (valueCleared)="onPlanCleared()">
                </app-single-select>
            </div>
        </ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default btn-green" [disabled]="disableCreate()"
            (click)="createSubscription()">
            <output *ngIf="isSpinner" class="spinner-border spinner-border-sm spinner-position" aria-hidden="true"></output>
            <span>Create</span>
        </button>
    </div>
</div>